import { JwtAxios } from '@/packaging';
export const poizonApi = {
  async GetPoizonApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetPoizonApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetPoizonApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetPoizonApiTemplate`, model);
    return responseModel;
  },
  async SetPoizonApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetPoizonApi', body);
    return responseModel;
  }
};
